import React from "react";
import Router from "./Router";
import GlobalStyles from "./GlobalStyles"
function App() {
  return (
    <div>
      <Router />
      <GlobalStyles />
    </div>
  );
}
export default App;